import {
	createSlice,
	createAsyncThunk,
	createEntityAdapter,
} from "@reduxjs/toolkit";
import productCollectionService from "services/productCollectionService";

export const getProductCollections = createAsyncThunk(
	"vino/productCollections/getProductCollections",
	async () => {
		const productCollections = await productCollectionService.all();
		return productCollections;
	}
);

const productCollectionsAdapter = createEntityAdapter({});

export const {
	selectAll: selectProductCollections,
	selectById: selectProductCollectionById,
} = productCollectionsAdapter.getSelectors(
	(state) => state.vino.productCollections
);

const productCollectionsSlice = createSlice({
	name: "vino/productCollections",
	initialState: productCollectionsAdapter.getInitialState(),
	reducers: {
		resetProductCollections: (state) =>
			productCollectionsAdapter.removeAll(state),
		setSelectedCollectionId: (state, action) => {
			state.selectedCollectionId = action.payload;
		},
	},

	extraReducers: {
		[getProductCollections.fulfilled]: productCollectionsAdapter.setAll,
	},
});

export const {
	resetProductCollections,
	setSelectedCollectionId,
} = productCollectionsSlice.actions;

export default productCollectionsSlice.reducer;
